module.exports = __webpack_public_path__ + "static/media/CNNsamplevideo3.d56c04a1.mp4";